import { PageView } from './views'
import { reducer } from './store'

export const routes = {
  page: '/:page',
}

export const routeToInstall = {
  id: 'pages',
  path: routes.page,
  component: PageView,
}

export const storeToInstall = {
  pages: reducer
}
